const MOVED: Record<string, string> = {
  rates: '/payroll?tab=rates',
  banks: '/finance/sales/banks',
}

export function movedConfigTab(tab: string | null | undefined): string | undefined {
  return tab ? MOVED[tab] : undefined
}
